"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var componentStyle = {
    base: {
        marginBottom: 18,
        fontSize: 36,
    },
};
exports.PageHeader = function (_a) {
    var children = _a.children;
    return (React.createElement("h2", { style: componentStyle.base }, children));
};
exports.PageHeader.displayName = 'PageHeader';



//////////////////
// WEBPACK FOOTER
// ./src/docs/common/Page/PageHeader.tsx
// module id = 620
// module chunks = 0